import { API } from '@/shared/api/modules';
import type { GetCreatedAlertsRequestDto } from '@/shared/api/modules/alerts';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export const getCreatedAlertsQueryOptions = (
  params: GetCreatedAlertsRequestDto
) =>
  queryOptions({
    queryKey: ['created-alerts-kpi', params],
    queryFn: async ({ signal }) =>
      await API.alerts.getCreatedAlertsKpi(params, { signal }),
    enabled: !!params.from && !!params.to,
    placeholderData: keepPreviousData,
  });
